import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import createPersistedState from 'vuex-persistedstate';

const state = {
	croppa: true,
	media_store: true,
	livepreview: true,
    inlinemod: false,
    auto_hide_notifications: true,
};

export default {
	namespaced: true,
    state,
    mutations,
    actions,
    getters
};



// WEBPACK FOOTER //
// ./src/store/features/index.js